import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { LocationAdd, LocationUpdate } from '../../../services/LoginPageService';

const AddLocationModal = ({open, setOpen, isAddButton, editLocation,setNotification,setRefreshData}) => {
    const[location,setLocation]=useState('');
    const [time,setTime] = useState('');
    const[description,setDescription]=useState('');
    
    const handleClose = () => {
        setOpen(false);
        ClearData();
    };

    useEffect(()=>{
        setLocation(editLocation?.location || '');
        setTime(editLocation?.time || '');
        setDescription(editLocation?.description || '');
    },[editLocation])

    const ClearData=()=>{
        setLocation('');
        setTime('');
        setDescription('');
        setRefreshData(oldValue => !oldValue);
    }

    const isValidInput = (inputValue) => {
        const regex = /^[A-Za-z\s]+$/;
        return regex.test(inputValue);
      };
    

      const handleLocationChange = (e) => {
        const inputValue = e.target.value;
        if (isValidInput(inputValue)) {
          setLocation(inputValue);
        } else {
          if (inputValue === '') {
            setLocation('');
          }
        }
      };

    const onSubmit = (e) => {
        e.preventDefault();
        isAddButton === true ?
        (
            LocationAdd({
                location: location,
                time:time,
                description :description,
            }, handleSuccess, handleException)
        ) : (
            LocationUpdate({
                id:editLocation.id,
                location: location,
                time:time,
                description :description,
            }, handleSuccess, handleException)
        );
    }

    const handleSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
            status: true,
            type: 'success',
            message: dataObject.message,
        });
        setTimeout(()=>{
            setOpen(false);
        }, 2000);

        setRefreshData(oldValue => !oldValue);
        ClearData();
    }

    const handleException = (errorObject, errorMessage) => {
        console.log(errorMessage);
        setNotification({
            status: true,
            type: 'error',
            message: errorMessage,
        });
        ClearData();
    }
    
    return (
        <div>
            <Dialog sx={{ '& .MuiDialog-paper': { width: '32%', maxHeight: '100%' } }}
            maxWidth="lg"
            open={open}>
                <form onSubmit={onSubmit}>
                    <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                        {isAddButton === true ? 'Add ' : 'Update '}Location
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{marginTop:'20px'}}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField 
                                fullWidth 
                                label="Location"
                                placeholder='Location'
                                variant="outlined"
                                required
                                onChange={handleLocationChange}
                                // onChange={(e) => { setLocation(e.target.value) }}
                                value={location}/>
                            </Grid>
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField 
                                    fullWidth 
                                    label="Time"
                                    placeholder='Time'
                                    variant="outlined"
                                    required
                                    type='time'
                                    onChange={(e) => {setTime(e.target.value) }}
                                    value={time}
                                    InputLabelProps={
                                        {
                                          shrink:true
                                        }
                                    }
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField 
                                    fullWidth 
                                    label="Description"
                                    placeholder='Description'
                                    variant="outlined"
                                    required
                                    onChange={(e) => { setDescription(e.target.value) }}
                                    value={description}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit'>
                        {
                            isAddButton ? 'Add' : 'update'
                        }       
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}

export default AddLocationModal
